import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export const tabsWrapperAnimation = {
    duration: 0.3,
    ease: "power1.in"
};
export function goToTab(props) {
    const { tab, tabs, wrapper, onComplete } = props;
    const tabRect = tab.getBoundingClientRect();
    const tabsRect = tabs.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const tabCenter = (tabRect.left + tabRect.right) / 2;
    const wrapperCenter = (wrapperRect.left + wrapperRect.right) / 2;
    let scrollPosition = Math.abs(tabsRect.x - wrapperRect.x);
    if (tabCenter < wrapperCenter && wrapperRect.left > tabsRect.left) {
        scrollPosition -= Math.min(wrapperRect.left - tabsRect.left, wrapperCenter - tabCenter);
    }
    if (tabCenter > wrapperCenter && wrapperRect.right < tabsRect.right) {
        scrollPosition += Math.min(tabsRect.right - wrapperRect.right, tabCenter - wrapperCenter);
    }
    gsap.to(wrapper, Object.assign(Object.assign({}, tabsWrapperAnimation), { scrollTo: {
            x: scrollPosition,
        }, onComplete }));
}
//# sourceMappingURL=goToTab.js.map